export default function themeLogger(logObjs) {
   if (logObjs) {
      logObjs.forEach((l) => {
         console.log(l.label, l.data);
      });
   }
}
